module.exports = __webpack_public_path__ + "static/media/7-nklane.f2ba381e.mp3";